/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import { fg } from '@atlassian/jira-feature-gating';
import servicesAndSkillsSetupActionPreloadedQueryParameters, {
	type ServicesAndSkillsSetupActionPreloadedQuery,
} from '@jira/servicedesk__workforce-optimization-routing/src/__generated__/ServicesAndSkillsSetupActionPreloadedQuery.graphql.ts';
import type { WorkforceOptimizationExperimentPageQuery } from './__generated__/WorkforceOptimizationExperimentPageQuery.graphql';
import workforceOptimizationExperimentPageQueryParameters from './__generated__/WorkforceOptimizationExperimentPageQuery$parameters.ts';

type WorkforceOptimizationEntryPointComponent = EntryPointComponent<
	{
		servicesAndSkillsSetupActionQuery?: ServicesAndSkillsSetupActionPreloadedQuery;
		teamCountsQuery?: WorkforceOptimizationExperimentPageQuery;
	},
	{},
	{},
	{
		cloudId: string;
		projectKey: string;
		orgId?: string;
	}
>;

export const workforceOptimizationEntryPoint: EntryPoint<
	WorkforceOptimizationEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForInteraction<WorkforceOptimizationEntryPointComponent>(
		/* webpackChunkName: "async-servicedesk-workforce-optimization", jiraSpaEntry: "async-servicedesk-workforce-optimization" */ './WorkforceOptimizationPage.tsx',
	),
	getPreloadProps: ({
		context: { match },
		tenantContext: { cloudId, orgId },
	}: EntryPointRouteParams) => {
		const projectKey = match.params.projectKey ?? '';
		const hasOrgId = orgId != null && orgId !== '';

		return {
			queries: {
				...(hasOrgId && fg('wfm-onboarding-updates')
					? {
							teamCountsQuery: {
								options: {
									fetchPolicy: 'store-or-network' as const,
								},
								parameters: workforceOptimizationExperimentPageQueryParameters,
								variables: {
									organizationId: `ari:cloud:platform::org/${orgId}`,
									siteId: cloudId,
									filter: null,
								},
							},
							servicesAndSkillsSetupActionQuery: {
								options: {
									fetchPolicy: 'store-or-network' as const,
								},
								parameters: servicesAndSkillsSetupActionPreloadedQueryParameters,
								variables: { cloudId, projectKey },
							},
						}
					: {}),
			},
			extraProps: { cloudId, projectKey, orgId },
		};
	},
});
